import { useMemo } from 'react'

import type { WebUrl } from '@/cms/webUrl'
import { noFollow, openInNewTab } from '@/utils/url'

export const useWebUrlRel = (webUrl?: WebUrl) => {
  const rel = useMemo(() => {
    if (!webUrl?.[0]) {
      return undefined
    }
    const shouldOpenInNewTab = openInNewTab(webUrl)
    const shouldNotFollow = noFollow(webUrl)
    if (!shouldOpenInNewTab && !shouldNotFollow) {
      return undefined
    }
    return [shouldOpenInNewTab ? 'noopener noreferrer' : '', shouldNotFollow ? 'nofollow' : '']
      .filter(Boolean)
      .join(' ')
  }, [webUrl])
  return rel
}
